import {
  Component,
  ContentChild,
  input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Observable, tap } from 'rxjs';
import { LoadingService } from '../../_services/loading.service';
import {
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';

@Component({
  selector: 'app-loading-indicator',
  imports: [AsyncPipe, MatProgressSpinner],
  templateUrl: './loading-indicator.component.html',
  standalone: true,
  styleUrl: './loading-indicator.component.css',
})
export class LoadingIndicatorComponent implements OnInit {
  loading$?: Observable<boolean>;

  detectRouteTransitions = input.required<boolean>();

  @ContentChild('loading')
  customLoadingIndicator: TemplateRef<any> | null = null;

  constructor(
    private loadingService: LoadingService,
    private router: Router,
  ) {
    this.loading$ = this.loadingService.loading$;
  }

  ngOnInit() {
    if (this.detectRouteTransitions())
      this.router.events
        .pipe(
          tap((event) => {
            if (event instanceof RouteConfigLoadStart)
              this.loadingService.loadingOn();
            else if (event instanceof RouteConfigLoadEnd)
              this.loadingService.loadingOff();
          }),
        )
        .subscribe();
  }
}
